import PropTypes from 'prop-types';
import React from 'react';
import Button from "../components/button";

var FullWidthButton = function FullWidthButton(_ref) {
  var handleClick = _ref.handleClick,
      buttonContent = _ref.buttonContent,
      disabled = _ref.disabled,
      disabledLayout = _ref.disabledLayout,
      note = _ref.note;
  return React.createElement("div", {
    className: "FullWidthButton"
  }, React.createElement("div", {
    className: "FullWidthButton-button-container"
  }, disabled && disabledLayout ? React.createElement("div", {
    className: "FullWidthButton-disabled-layout"
  }, disabledLayout) : React.createElement(Button, {
    className: "FullWidthButton-button",
    onClick: handleClick,
    disabled: disabled
  }, buttonContent)), note && React.createElement("div", {
    className: "FullWidthButton-add-note"
  }, note));
};

FullWidthButton.defaultProps = {
  disabled: false
};
FullWidthButton.propTypes = {
  handleClick: PropTypes.func.isRequired,
  buttonContent: PropTypes.oneOfType([PropTypes.element, PropTypes.string]).isRequired,
  note: PropTypes.string,
  disabled: PropTypes.bool,
  disabledLayout: PropTypes.element
};
export default FullWidthButton;